<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M4.5,9.5V2.3c0,-0.4418,0.3582,-0.8,0.8,-0.8h13.4c0.4418,0,0.8,0.3582,0.8,0.8v13.4c0,0.4418,-0.3582,0.8,-0.8,0.8h-5.4"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="4.5"
        y1="3.5"
        x2="19.4"
        y2="3.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M13.5,14.1v-2.2c0,-0.2209,-0.1791,-0.4,-0.4,-0.4h-0.14"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M17.1,10.5h-1.2c-0.2209,0,-0.4,0.1791,-0.4,0.4v3.2c0,0.2209,0.1791,0.4,0.4,0.4h1.2c0.2209,0,0.4,-0.1791,0.4,-0.4v-3.2C17.5,10.6791,17.3209,10.5,17.1,10.5z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M15.0152,6.5l2.4823,0.0062l-4.4567,3.0237l-1.5481,-1.534L8.6812,9.51M17.0708,8.8262l0.4267,-2.3041"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <g id="coin">
        <path
          d="M9.8333,16.32c0,0,0,1.5052,0,1.6852c0,0.6961,-1.8632,1.5047,-4.1652,1.5047c-2.302,0,-4.1682,-0.8085,-4.1682,-1.4963c0,-0.1541,0,-1.6935,0,-1.6935"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
        <path
          d="M9.8333,16.3112c0,0.912,-1.8422,1.5223,-4.1513,1.5223c-2.3091,0,-4.1809,-0.6103,-4.1809,-1.5223c0,-0.539,0.6539,-1.0177,1.6656,-1.3191"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
      </g>
      <g id="coin">
        <path
          d="M11.5,13.3422c0,0,0,1.5052,0,1.6852c0,0.6961,-1.8632,1.5047,-4.1652,1.5047c-2.302,0,-4.1682,-0.8085,-4.1682,-1.4963c0,-0.1541,0,-1.6935,0,-1.6935"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
        <path
          d="M7.3487,11.6821c2.3091,0,4.1513,0.7393,4.1513,1.6513s-1.8422,1.5223,-4.1513,1.5223c-2.3091,0,-4.1809,-0.6103,-4.1809,-1.5223S5.0396,11.6821,7.3487,11.6821z"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
